import type { OpportunityWorkbenchColumnKey } from "../types";

export const CRM_OPPORTUNITY_WORKBENCH_VISIBLE_COLUMNS_STORAGE_KEY =
  "crm.opportunity_workbench.visible_columns.v3";

export const crmOpportunityWorkbenchColumnOptions: Array<{
  key: OpportunityWorkbenchColumnKey;
  label: string;
  required?: boolean;
  pinnedEnd?: boolean;
}> = [
  { key: "opportunity", label: "商机", required: true },
  { key: "orgCustomer", label: "学校/客户" },
  { key: "monthCount", label: "月份/人数" },
  { key: "signInfo", label: "商机进度" },
  { key: "stage", label: "当前阶段" },
  { key: "customization", label: "关联定制" },
  { key: "itinerary", label: "最近行程" },
  { key: "followup", label: "最近跟进" },
  { key: "owners", label: "负责人" },
  { key: "createdAt", label: "创建时间" },
  { key: "updatedAt", label: "修改时间" },
  { key: "actions", label: "操作", required: true, pinnedEnd: true },
];

export const crmOpportunityWorkbenchDefaultVisibleColumns: OpportunityWorkbenchColumnKey[] =
  crmOpportunityWorkbenchColumnOptions.map((item) => item.key);
